import { ActivityEntityName, PurchaseOrderDeliverOptions } from '../../../../entities';
import { MergeField, MergeSchema, getSchema } from '../../decorators';

@MergeSchema({
    entity: ActivityEntityName.PurchaseOrder,
    name: 'PurchaseOrderMergeSchema',
})
export class PurchaseOrderMergeData {
    @MergeField()
    poNumber?: string;

    @MergeField()
    poDate?: string;

    @MergeField()
    reference?: string;

    @MergeField()
    deliveryDate?: string;

    @MergeField()
    deliveryInstructions?: string;

    @MergeField()
    comment?: string;

    @MergeField()
    status: string;

    @MergeField()
    createdBy?: string;

    @MergeField()
    chargeable: string;

    @MergeField()
    taxRate?: string;

    @MergeField()
    taxInclusiveOption?: string;

    @MergeField()
    subTotal?: string;

    @MergeField()
    total?: string;

    @MergeField()
    tax?: string;

    @MergeField()
    createdAt?: string;

    @MergeField()
    updatedAt?: string;

    @MergeField()
    job?: string;

    // @MergeField({ arraySchemaName: "PurchaseOrderLineMergeSchema" })
    // lines: PurchaseOrderLinesMergeData[]
}

export const PurchaseOrderMergeSchema = getSchema(PurchaseOrderMergeData);

@MergeSchema({
    entity: ActivityEntityName.PurchaseOrderLine,
    name: 'PurchaseOrderLineMergeSchema',
})
export class PurchaseOrderLineMergeData {
    @MergeField()
    name?: string;

    @MergeField()
    description?: string;

    @MergeField()
    quantity?: string;

    @MergeField()
    price?: string;

    @MergeField()
    tax: string;

    @MergeField()
    subTotal: string;

    @MergeField()
    total: string;

    @MergeField()
    codeUoM?: string;

    @MergeField()
    glCode?: string;

    @MergeField()
    taxRate?: string;
}

export const PurchaseOrderLineMergeSchema = getSchema(PurchaseOrderLineMergeData);

@MergeSchema({
    entity: ActivityEntityName.PurchaseOrderLines,
})
export class PurchaseOrderLinesMergeData {
    @MergeField(
        {
            displayName: "Purchase Order Lines",
            arraySchemaName: 'PurchaseOrderLineMergeSchema'
        }
    )
    lines?: PurchaseOrderLineMergeData[];
}

export const PurchaseOrderLinesMergeSchema = getSchema(PurchaseOrderLinesMergeData);

@MergeSchema({
    entity: ActivityEntityName.PurchaseOrderSupplier,
})
export class PurchaseOrderSupplierMergeData {
    @MergeField()
    name?: string;

    @MergeField()
    phone?: string;

    @MergeField({
        displayName: 'Street1 (deprecated)'
    })
    street1?: string;

    @MergeField({
        displayName: 'Street2 (deprecated)'
    })
    street2?: string;

    @MergeField({
        displayName: 'Suburb (deprecated)'
    })
    suburb?: string;

    @MergeField({
        displayName: 'State (deprecated)'
    })
    state?: string;

    @MergeField({
        displayName: 'Country (deprecated)'
    })
    country?: string;

    @MergeField({
        displayName: 'Postcode (deprecated)'
    })
    postcode?: string;

    @MergeField()
    markupPercent?: string;

    @MergeField()
    email?: string;

    @MergeField()
    contactName?: string;
}

export const PurchaseOrderSupplierMergeSchema = getSchema(PurchaseOrderSupplierMergeData);

@MergeSchema({
    entity: ActivityEntityName.PurchaseOrderDeliveryAddress
})
export class PurchaseOrderDeliveryAddressMergeData {

    @MergeField()
    street1: string;

    @MergeField()
    street2: string;

    @MergeField()
    suburb: string;

    @MergeField()
    state: string;

    @MergeField()
    postcode: string;

    @MergeField()
    county: string;

    @MergeField()
    country: string;

    @MergeField()
    fullAddress: string;

    @MergeField()
    contactName: string;

    @MergeField()
    contactPhone: string;

    @MergeField()
    deliveryOptions: PurchaseOrderDeliverOptions
}

export const PurchaseOrderDeliveryAddressMergeSchema = getSchema(PurchaseOrderDeliveryAddressMergeData);
